import { AppAccountMenu } from './AppAccountMenu';
import { AppBreadcrumb } from './AppBreadcrumb';
import { AppHamburgerMenu } from './AppHamburgerMenu';

export const AppNavigation = () => {
  return (
    <header className="flex items-center border-b border-border h-16">
      <AppHamburgerMenu />
      <AppBreadcrumb />
      <AppAccountMenu />
    </header>
  );
};
